export default "__VITE_ASSET__C2e2Qsbr__"